import { useQuery } from '@tanstack/react-query';
import * as api from '../api/client';

/**
 * Deliberately unlike useIncidents, which polls every 60s. A 366-day fleet
 * aggregate is a much heavier query and reports are read deliberately rather
 * than watched, so these do not poll. Live updating stays on the dashboard.
 */
const REPORT_QUERY = {
  staleTime: 5 * 60_000,
  refetchOnWindowFocus: false,
} as const;

export function useFleetReport(params: api.ReportParams) {
  return useQuery({ queryKey: ['report', 'fleet', params], queryFn: () => api.getFleetReport(params), ...REPORT_QUERY });
}

export function useAvailabilityReport(params: api.ReportParams) {
  return useQuery({ queryKey: ['report', 'availability', params], queryFn: () => api.getAvailabilityReport(params), ...REPORT_QUERY });
}

export function useIncidentRateReport(params: api.ReportParams) {
  return useQuery({ queryKey: ['report', 'incidents', params], queryFn: () => api.getIncidentRateReport(params), ...REPORT_QUERY });
}

export function useResponseReport(params: api.ReportParams) {
  return useQuery({ queryKey: ['report', 'response', params], queryFn: () => api.getResponseReport(params), ...REPORT_QUERY });
}

export function useScorecard(id: number, params: Omit<api.ReportParams, 'scope'>) {
  return useQuery({
    queryKey: ['report', 'scorecard', id, params],
    queryFn: () => api.getScorecard(id, params),
    enabled: Number.isFinite(id),
    ...REPORT_QUERY,
  });
}
